export default "__VITE_ASSET__C9yx$EIy__"